export const FB_ID = process.env.REACT_APP_FB_ID;
